import type { Styles } from '@adornis/ass/style.js';
import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import '@adornis/chemistry/elements/components/x-empty-placeholder.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import type { ColorType } from '@adornis/chemistry/elements/theming/coloring-system.js';
import { XTableView } from '@adornis/data-view/client/x-data-view-table.js';
import '@adornis/data-view/client/x-sorting-card.js';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element x-data-view-table
 */
@customElement('tr-data-view-table')
export class TrTableView<T extends typeof AdornisEntity> extends XTableView<T> {
  @property({ attribute: true }) coloring?: ColorType;

  protected get _getColoring() {
    return this.coloring ?? this.colors.light;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          overflow: 'auto',
          'tr-grid > div:nth-child(1) > *': {
            backgroundColor: this._getColoring.shade(50),
            minHeight: `CALC( ${this.spacing.lg} + ${this.spacing.xs} )`,
          },
          '.column-selector': {
            background: 'unset !important',
          },
        },
      } as Styles,
    ];
  }
}
